import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isSuperuser, superuserRedirect } from '../utils/permissions';

export const ProtectedRoute = ({ children, requireSuperuser = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireSuperuser && !isSuperuser(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  // The platform operator has no company: tenant screens (dashboard,
  // /modules/*, billing) only show mixed all-tenant data or 403s for it.
  const redirect = superuserRedirect(user, location.pathname);
  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  return children;
};
